import { toast } from "react-toastify";
import React, { useState, useEffect, useCallback } from "react";
import inventoryService from "../../../shared/api/animal/inventoryService";

const TABS = ["FEED", "MEDICINE", "VACCINE"];
const UNITS = {
  FEED: ["KG", "LITRE", "UNIT"],
  MEDICINE: ["ML", "TABLET", "GRAM", "BOTTLE", "UNIT"],
  VACCINE: ["DOSE", "VIAL", "ML"],
};

const unitHelp = {
  KG: "Dry feed, grain, pellets and solid supplements. Feeding grams are deducted as kg.",
  LITRE: "Liquid feed, liquid medicine and water additives. Planned ml is deducted as litre.",
  UNIT: "Countable items like tablets, sachets, injections and vials.",
  ML: "Stock is stored and deducted in millilitres.",
  TABLET: "Each tablet is one stock unit.",
  GRAM: "Medicine stock is stored in grams; mg doses are converted safely.",
  BOTTLE: "Bottle stock is countable and requires a matching bottle-based workflow.",
  DOSE: "Each configured dose is one stock unit.",
  VIAL: "Doses per vial is required so dose consumption is converted correctly.",
};

const Styles = () => (
  <style>{`
    .page-header { display:flex; justify-content:space-between; align-items:center; margin-bottom:2rem; flex-wrap:wrap; gap:1rem; }
    .page-title { font-size:1.875rem; font-weight:700; color:#172b21; margin:0; background:none; -webkit-text-fill-color:initial; }
    .page-subtitle { margin:.45rem 0 0; color:#75877d; line-height:1.6; max-width:850px; }
    .btn { padding:0.625rem 1.25rem; border-radius:10px; font-weight:600; text-decoration:none; transition:all .2s ease; font-size:.875rem; border:none; cursor:pointer; display:inline-flex; align-items:center; gap:.5rem; }
    .btn-primary { background:#0f835f; color:white; box-shadow:0 4px 12px rgba(15,131,95,.15); }
    .btn-primary:hover { background:#076b4e; }
    .btn-secondary { background:rgba(45,55,72,.8); color:#E2E8F0; border:1px solid rgba(255,255,255,.1); }
    .btn-secondary:hover { background:rgba(55,65,81,.9); border-color:rgba(255,255,255,.2); }
    .enum-info { margin:-.65rem 0 1.3rem; padding:1rem 1.1rem; border-radius:14px; background:rgba(99,102,241,.1); border:1px solid rgba(99,102,241,.25); color:#c7d2fe; line-height:1.55; }
    .inventory-tabs { display:flex; gap:.35rem; margin:0 0 1.25rem; padding:.3rem; width:max-content; max-width:100%; border-radius:12px; background:#edf4ef; border:1px solid #d9e8de; }
    .inventory-tab { border:0; border-radius:9px; padding:.72rem 1.4rem; color:#52665b; background:transparent; cursor:pointer; font-weight:700; }
    .inventory-tab.active { color:#fff; background:#0d805a; box-shadow:0 2px 8px rgba(15,131,95,.15); }
    .table-container { background:#fff; border-radius:16px; border:1px solid rgba(255,255,255,.08); overflow-x:auto; box-shadow:0 4px 20px rgba(0,0,0,.3); }
    .inventory-table { width:100%; border-collapse:collapse; min-width:930px; table-layout:auto; }
    .inventory-table th,.inventory-table td { padding:1rem 1.2rem; text-align:left; border-bottom:1px solid rgba(255,255,255,.06); vertical-align:middle; }
    .inventory-table th { font-size:.75rem; text-transform:uppercase; letter-spacing:.05em; color:#64748B; font-weight:600; background:rgba(30,37,54,.5); }
    .inventory-table td { color:#E2E8F0; font-weight:500; }
    .inventory-table tbody tr { transition:all .15s ease; }
    .inventory-table tbody tr:hover { background:rgba(99,102,241,.08); }
    .chip { display:inline-flex; align-items:center; border-radius:999px; padding:.32rem .65rem; font-size:.75rem; font-weight:800; border:1px solid rgba(148,163,184,.22); background:rgba(15,23,42,.55); color:#cbd5e1; }
    .low-stock-alert { color:#a46a0a; font-weight:600; display:inline-flex; align-items:center; gap:.5rem; }
    .low-stock-alert::before { content:''; width:8px; height:8px; background:#FBBF24; border-radius:50%; }
    .in-stock { color:#34D399; display:flex; align-items:center; gap:.5rem; }
    .in-stock::before { content:''; width:8px; height:8px; background:#34D399; border-radius:50%; }
    .expired-stock { color:#b73c42; display:inline-flex; align-items:center; gap:.5rem; font-weight:700; }
    .expired-stock::before { content:''; width:8px; height:8px; background:#fb7185; border-radius:50%; }
    .action-buttons { display:flex; gap:.5rem; flex-wrap:nowrap; align-items:center; }
    .action-btn { background:rgba(99,102,241,.15); color:#A5B4FC; padding:.5rem .8rem; border-radius:8px; border:none; cursor:pointer; font-size:.8rem; font-weight:600; transition:all .2s ease; display:inline-flex; align-items:center; gap:.4rem; }
    .action-btn:hover { background:rgba(99,102,241,.25); transform:translateY(-1px); }
    .action-btn.restock { background:rgba(34,197,94,.15); color:#86efac; }
    .action-btn.restock:hover { background:rgba(34,197,94,.24); }
    .action-btn.history { background:rgba(59,130,246,.15); color:#93c5fd; }
    .action-btn.edit { background:rgba(245,158,11,.15); color:#FBBF24; }
    .action-btn.edit:hover { background:rgba(245,158,11,.25); }
    .action-btn.delete { background:rgba(239,68,68,.15); color:#F87171; }
    .action-btn.delete:hover { background:rgba(239,68,68,.25); }
    .modal-overlay { position:fixed; inset:0; background:rgba(0,0,0,.75); backdrop-filter:blur(8px); display:flex; align-items:center; justify-content:center; z-index:1001; padding:1rem; animation:fadeIn .2s ease-out; }
    .modal-content { background:linear-gradient(145deg,#1E2536 0%,#1A1F2E 100%); padding:2rem; border-radius:20px; width:90%; max-width:540px; border:1px solid rgba(255,255,255,.1); color:#F7FAFC; box-shadow:0 25px 50px rgba(0,0,0,.5); animation:slideUp .3s ease-out; }
    .modal-header { display:flex; justify-content:space-between; align-items:center; margin-bottom:1.5rem; }
    .modal-title { font-size:1.375rem; font-weight:700; margin:0; }
    .close-btn { background:rgba(255,255,255,.05); border:none; font-size:1.75rem; cursor:pointer; color:#64748B; width:36px; height:36px; border-radius:10px; display:flex; align-items:center; justify-content:center; transition:all .2s ease; }
    .close-btn:hover { background:rgba(255,255,255,.1); color:#F7FAFC; transform:rotate(90deg); }
    .form-group { display:flex; flex-direction:column; margin-bottom:1.25rem; }
    .form-group label { margin-bottom:.5rem; font-weight:600; color:#94A3B8; font-size:.875rem; }
    .form-input,.form-select { width:100%; padding:.8rem 1rem; border:1px solid rgba(255,255,255,.1); border-radius:10px; font-size:.95rem; background:rgba(30,37,54,.8); color:#fff; transition:all .2s ease; }
    .form-input:focus,.form-select:focus { outline:none; border-color:#6366F1; box-shadow:0 0 0 3px rgba(99,102,241,.2); }
    .error-message { color:#F87171; background:rgba(239,68,68,.12); padding:1rem; border-radius:12px; text-align:center; border:1px solid rgba(239,68,68,.3); margin-bottom:1rem; }
    .hint { color:#94A3B8; font-size:.8rem; margin-top:.35rem; line-height:1.45; }
    .select-row { display:flex; gap:.5rem; align-items:center; }
    .plus-btn { width:40px; height:40px; border-radius:10px; border:1px dashed rgba(255,255,255,.18); background:rgba(255,255,255,.04); color:#E2E8F0; cursor:pointer; font-weight:900; font-size:1.1rem; display:flex; align-items:center; justify-content:center; transition:all .2s ease; }
    .plus-btn:hover { background:rgba(99,102,241,.15); border-color:rgba(99,102,241,.5); transform:translateY(-1px); }
    .summary-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:.75rem;margin-bottom:1.25rem}.summary-card{padding:1rem;border-radius:12px;background:#f8faf9;border:1px solid #dce7e1}.summary-label{display:block;color:#64748b;font-size:.75rem;margin-bottom:.35rem}.summary-value{color:#173d30;font-size:1.05rem;font-weight:800}.history-table{width:100%;border-collapse:collapse;min-width:680px;color:#34483e}.history-table th,.history-table td{padding:.8rem;text-align:left;border-bottom:1px solid #e3ebe7}.history-table th{color:#53635b;background:#f2f6f4;font-size:.75rem;text-transform:uppercase}.history-table td{color:#34483e}.history-modal{background:#fff;color:#17251f;border:1px solid #dbe7e0}.history-modal .modal-title{color:#17251f}.history-modal .hint{color:#64748b}.history-modal .close-btn{color:#64748b;background:#f4f7f5}
    .cost-modal { max-width:600px; background:#fff; color:#17251f; border:1px solid #dbe7e0; }
    .cost-modal .modal-title { color:#17251f; }
    .cost-modal .close-btn { color:#64748b; background:#f4f7f5; }
    .cost-modal .close-btn:hover { color:#17251f; background:#e9f1ed; }
    .cost-intro { color:#5f7168; line-height:1.55; margin:-.5rem 0 1.25rem; }
    .cost-stock-summary { display:flex; justify-content:space-between; align-items:center; gap:1rem; padding:1rem 1.1rem; border-radius:12px; background:#f2f8f5; border:1px solid #d9ebe1; margin-bottom:1.25rem; }
    .cost-stock-summary span { color:#607169; font-size:.86rem; }
    .cost-stock-summary strong { color:#173d30; font-size:1.05rem; }
    .cost-mode-label { display:block; color:#34483e; font-size:.875rem; font-weight:700; margin-bottom:.6rem; }
    .cost-mode-switch { display:grid; grid-template-columns:1fr 1fr; gap:.5rem; padding:.3rem; background:#f2f5f3; border:1px solid #dbe5df; border-radius:12px; margin-bottom:1.25rem; }
    .cost-mode-option { border:0; border-radius:9px; padding:.72rem .8rem; background:transparent; color:#53635b; font-weight:700; cursor:pointer; transition:all .18s ease; }
    .cost-mode-option.active { background:#fff; color:#0f7b5b; box-shadow:0 2px 8px rgba(24,71,55,.12); }
    .cost-modal .form-group label { color:#34483e; }
    .cost-modal .form-input { background:#fff; color:#17251f; border-color:#cbdad2; }
    .cost-modal .form-input:focus { border-color:#158563; box-shadow:0 0 0 3px rgba(21,133,99,.13); }
    .cost-preview { display:grid; grid-template-columns:1fr 1fr; gap:.75rem; margin:1.25rem 0; }
    .cost-preview-card { padding:1rem; border:1px solid #dce7e1; background:#f8faf9; border-radius:12px; }
    .cost-preview-card span { display:block; color:#6b7c73; font-size:.78rem; margin-bottom:.35rem; }
    .cost-preview-card strong { color:#173d30; font-size:1.1rem; }
    .cost-help { color:#687970; font-size:.8rem; line-height:1.45; margin-top:.4rem; }
    .cost-error { padding:.75rem .9rem; border-radius:10px; color:#b42318; background:#fff1f0; border:1px solid #ffc9c5; font-size:.85rem; margin-bottom:1rem; }
    .cost-modal-actions { display:flex; justify-content:flex-end; gap:.75rem; margin-top:1rem; }
    .cost-cancel-btn { background:#fff; color:#34483e; border:1px solid #cad8d0; }
    .cost-save-btn { background:#13835f; color:#fff; box-shadow:0 4px 12px rgba(19,131,95,.22); }
    .cost-save-btn:hover { background:#0f6f50; transform:translateY(-1px); }
    .cost-save-btn:disabled { opacity:.6; cursor:not-allowed; transform:none; }
    @media (max-width:700px) { .summary-grid{grid-template-columns:1fr 1fr}.inventory-tabs{width:100%}.inventory-tab{flex:1;padding:.7rem .6rem}.modal-content{padding:1.25rem}.cost-preview { grid-template-columns:1fr; } .cost-stock-summary { align-items:flex-start; flex-direction:column; } }
    @keyframes fadeIn { from{opacity:0} to{opacity:1} }
    @keyframes slideUp { from{opacity:0; transform:translateY(20px)} to{opacity:1; transform:translateY(0)} }
  `}</style>
);

const EditIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{ width: 16, height: 16 }}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688A1.875 1.875 0 1121.2 5.45L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zM16.863 4.487L19.5 7.125" />
  </svg>
);

const DeleteIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{ width: 16, height: 16 }}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21a48.108 48.108 0 011.022.166M4.772 5.79a48.108 48.108 0 013.478-.397m7.5 0v-.916a2.25 2.25 0 00-2.09-2.201 51.964 51.964 0 00-3.32 0A2.25 2.25 0 007.82 4.477v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
  </svg>
);

const InventoryFormModal = ({ isOpen, onClose, onSave, initialData, category }) => {
  const isEditing = !!initialData;
  const [formData, setFormData] = useState({
    itemName: "",
    quantity: "",
    unit: "KG",
    minThreshold: 10,
    totalCost: "",
    expiryDate: "",
    dosesPerVial: "",
  });

  useEffect(() => {
    if (!isOpen) return;
    const actualCategory = initialData?.itemCategory || initialData?.type || category;
    const availableUnits = UNITS[actualCategory] || UNITS.FEED;
    setFormData({
      itemName: initialData?.itemName || "",
      quantity: initialData?.quantity ?? "",
      unit: availableUnits.includes(initialData?.unit) ? initialData.unit : availableUnits[0],
      minThreshold: initialData?.minThreshold ?? 10,
      totalCost: "",
      expiryDate: initialData?.expiryDate || "",
      dosesPerVial: initialData?.dosesPerVial ?? "",
    });
  }, [initialData, isOpen, category]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const submit = async (e) => {
    e.preventDefault();
    const actualCategory = initialData?.itemCategory || initialData?.type || category;
    const quantity = Number(formData.quantity);
    const totalCost = Number(formData.totalCost);
    const submission = {
      ...initialData,
      itemName: formData.itemName.trim(),
      itemCategory: actualCategory,
      type: actualCategory,
      quantity: quantity || 0,
      unit: formData.unit,
      minThreshold: Number(formData.minThreshold) || 0,
      expiryDate: actualCategory === "FEED" ? null : formData.expiryDate,
      dosesPerVial: actualCategory === "VACCINE" && formData.unit === "VIAL" ? Number(formData.dosesPerVial) : null,
      ...(!isEditing ? { purchaseTotalCost: totalCost, costPerUnit: quantity > 0 ? totalCost / quantity : 0 } : {}),
    };
    await onSave(initialData?.id, submission);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">{isEditing ? `Edit ${categoryLabel(category)}` : `Add ${categoryLabel(category)}`}</div>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={submit}>
          <div className="form-group">
            <label>{category === "MEDICINE" ? "Medicine Name" : category === "VACCINE" ? "Vaccine Name" : "Item Name"}</label>
            <input className="form-input" name="itemName" value={formData.itemName} onChange={onChange} required />
          </div>

          <div className="form-group">
            <label>{isEditing ? "Current Quantity" : `Initial Quantity (${formData.unit})`}</label>
            <input className="form-input" name="quantity" type="number" min={isEditing?undefined:"0.001"} step="0.001" value={formData.quantity} onChange={onChange} required disabled={isEditing}/>
          </div>

          {!isEditing && <div className="form-group">
            <label>Total Purchase Cost (₹)</label>
            <input className="form-input" name="totalCost" type="number" step="0.01" min="0" value={formData.totalCost} onChange={onChange} required/>
            <div className="hint">Calculated cost per {formData.unit}: ₹{(Number(formData.quantity)>0?(Number(formData.totalCost)||0)/Number(formData.quantity):0).toFixed(2)}</div>
          </div>}
          <div className="form-group">
            <label>Unit</label>
            <select className="form-select" name="unit" value={formData.unit} onChange={onChange} required disabled={isEditing}>
              {(UNITS[category] || UNITS.FEED).map((u) => (<option key={u} value={u}>{categoryLabel(u)}</option>))}
            </select>
            <div className="hint">{unitHelp[formData.unit]}</div>
          </div>

          {category !== "FEED" && <div className="form-group">
            <label>Expiry Date</label>
            <input className="form-input" name="expiryDate" type="date" min={new Date().toISOString().slice(0,10)} value={formData.expiryDate} onChange={onChange} required />
          </div>}

          {category === "VACCINE" && formData.unit === "VIAL" && <div className="form-group">
            <label>Doses per Vial</label>
            <input className="form-input" name="dosesPerVial" type="number" min="0.001" step="0.001" value={formData.dosesPerVial} onChange={onChange} required />
            <div className="hint">Required to convert administered doses into vial stock. One vial is never assumed to equal one dose.</div>
          </div>}

          <div className="form-group">
            <label>Low Stock Threshold</label>
            <input className="form-input" name="minThreshold" type="number" step="0.001" value={formData.minThreshold} onChange={onChange} required />
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: ".75rem", marginTop: "1rem" }}>
            <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
};

const RestockModal=({item,onClose,onSave})=>{const[quantity,setQuantity]=useState("");const[totalCost,setTotalCost]=useState("");const[expiryDate,setExpiryDate]=useState(item?.expiryDate||"");const[saving,setSaving]=useState(false);if(!item)return null;const category=categoryOf(item);const needsExpiry=category==="MEDICINE"||category==="VACCINE";const unitCost=Number(quantity)>0?(Number(totalCost)||0)/Number(quantity):0;const submit=async(e)=>{e.preventDefault();setSaving(true);try{await onSave(item.id,Number(quantity),unitCost,needsExpiry?expiryDate:null);}finally{setSaving(false);}};return <div className="modal-overlay" onClick={onClose}><div className="modal-content" onClick={e=>e.stopPropagation()}><div className="modal-header"><div className="modal-title">Restock {item.itemName}</div><button className="close-btn" onClick={onClose}>&times;</button></div><div className="enum-info" style={{marginTop:0}}>Current stock: <b>{Number(item.quantity||0).toLocaleString()} {item.unit}</b></div><form onSubmit={submit}><div className="form-group"><label>Total quantity to add ({item.unit})</label><input autoFocus className="form-input" type="number" min="0.001" step="0.001" value={quantity} onChange={e=>setQuantity(e.target.value)} required/></div><div className="form-group"><label>Total Purchase Cost (₹)</label><input className="form-input" type="number" min="0" step="0.01" value={totalCost} onChange={e=>setTotalCost(e.target.value)} required/><div className="hint">Calculated cost per {item.unit}: ₹{unitCost.toFixed(2)}. Total purchase cost ₹{(Number(totalCost)||0).toFixed(2)} will be added.</div></div>{needsExpiry&&<div className="form-group"><label>Expiry Date for Current Stock</label><input className="form-input" type="date" min={new Date().toISOString().slice(0,10)} value={expiryDate} onChange={e=>setExpiryDate(e.target.value)} required/><div className="hint">The item cannot be administered after this date.</div></div>}<div style={{display:"flex",justifyContent:"flex-end",gap:".75rem"}}><button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button><button className="btn btn-primary" disabled={saving}>{saving?"Saving...":"Save Restock"}</button></div></form></div></div>};

const HistoryModal=({data,loading,onClose})=>{if(!loading&&!data)return null;const unit=data?.unit||"UNIT";const money=v=>`₹${Number(v||0).toLocaleString("en-IN",{minimumFractionDigits:2,maximumFractionDigits:2})}`;const qty=v=>Number(v||0).toLocaleString(undefined,{maximumFractionDigits:3});const cards=data?[[`Total ${unit} Added`,`${qty(data.totalQuantity)} ${unit}`],[`${unit} Consumed`,`${qty(data.consumedQuantity)} ${unit}`],[`Available ${unit}`,`${qty(data.currentQuantity)} ${unit}`],["Total Cost",money(data.totalCost)],["Cost Consumed",money(data.consumedCost)],["Remaining Stock Cost",money(data.remainingCost)]]:[];return <div className="modal-overlay" onClick={onClose}><div className="modal-content history-modal" style={{maxWidth:920}} onClick={e=>e.stopPropagation()}><div className="modal-header"><div><div className="modal-title">Stock History{data?` — ${data.itemName}`:""}</div><div className="hint">Costs follow weighted-average stock value.</div></div><button className="close-btn" onClick={onClose}>&times;</button></div>{loading?<div style={{padding:"3rem",textAlign:"center",color:"#64748b"}}>Loading history...</div>:<><div className="summary-grid">{cards.map(([l,v])=><div className="summary-card" key={l}><span className="summary-label">{l}</span><span className="summary-value">{v}</span></div>)}</div><div style={{overflowX:"auto"}}><table className="history-table"><thead><tr><th>Date</th><th>Entry</th><th>Stock Added</th><th>Cost / {unit}</th><th>Entry Cost</th></tr></thead><tbody>{(data.entries||[]).map(e=><tr key={e.id}><td>{new Date(e.createdAt).toLocaleString()}</td><td><span className="chip">{e.type==="RESTOCK"?"Restock":e.type==="INITIAL_STOCK"?"Initial Stock":"Opening Balance"}</span></td><td>{qty(e.quantityAdded)} {unit}</td><td>{money(e.costPerUnit)}</td><td>{money(e.totalCost)}</td></tr>)}</tbody></table></div></>}</div></div>};

function categoryOf(item) {
  return item?.itemCategory || item?.type || "-";
}

function categoryLabel(value) {
  return String(value || "").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
}

function isExpired(item) {
  return Boolean(item?.expiryDate && item.expiryDate < new Date().toISOString().slice(0, 10));
}

export default function InventoryManagementPage() {
  const [activeTab,setActiveTab]=useState("FEED");
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [restockItem,setRestockItem]=useState(null);
  const [history,setHistory]=useState(null);
  const [historyLoading,setHistoryLoading]=useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const inv=await inventoryService.getAllInventory();
      setInventory(Array.isArray(inv) ? inv : []);
    } catch (e) {
      console.error(e);
      setError("Failed to load data. Please check the backend server.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const saveInventory = async (id, dto) => {
    try {
      if (id) await inventoryService.updateInventory(id, dto);
      else await inventoryService.addInventory(dto);
      setIsFormModalOpen(false);
      await load();
    } catch (e) {
      console.error(e);
      toast.error(inventoryService._apiMsg ? inventoryService._apiMsg(e) : "Failed to save inventory.");
    }
  };

  const restockInventory = async (id,quantity,costPerUnit,expiryDate) => {
    try {
      await inventoryService.restockInventory(id,quantity,costPerUnit,expiryDate);setRestockItem(null);
      await load();
    } catch (e) {
      console.error(e);
      toast.error(e?.response?.data?.message || "Failed to restock inventory.");
    }
  };

  const visibleInventory=inventory.filter((item)=>{
    const category=categoryOf(item);
    if(activeTab==="FEED")return !["MEDICINE","VACCINE"].includes(category);
    return category===activeTab;
  });

  const showHistory=async(item)=>{setHistory(null);setHistoryLoading(true);try{setHistory(await inventoryService.getInventoryHistory(item.id));}catch(e){toast.error("Failed to load stock history.");}finally{setHistoryLoading(false);}};

  const deleteInventory = async (id) => {
    try {
      const impact = await inventoryService.getDeleteImpact(id);
      const linked = Object.entries(impact?.linked || {}).filter(([, count]) => Number(count) > 0);
      const detail = linked.length
        ? `\n\nLinked records that will also be removed or unlinked:\n${linked.map(([name, count]) => `• ${name.replace(/([A-Z])/g, " $1")}: ${count}`).join("\n")}`
        : "\n\nNo linked operational records were found.";
      if (!window.confirm(`Permanently delete “${impact?.itemName || "this inventory item"}”?${detail}\n\nThis action cannot be undone.`)) return;
      await inventoryService.deleteInventory(id, true);
      await load();
    } catch (e) {
      console.error(e);
      toast.error(e?.response?.data?.message || "Failed to delete item.");
    }
  };

  return (
    <>
      <Styles />
      <div className="page-header">
        <div>
          <h1 className="page-title">Inventory Management</h1>
          <p className="page-subtitle">Initial purchases and every restock record quantity and unit cost. Consumption remains automatic.</p>
        </div>
        <button className="btn btn-primary" onClick={() => { setSelectedItem(null); setIsFormModalOpen(true); }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
          Add {categoryLabel(activeTab)}
        </button>
      </div>

      <div className="inventory-tabs" role="tablist" aria-label="Inventory category">
        {TABS.map(tab=><button key={tab} type="button" role="tab" aria-selected={activeTab===tab} className={`inventory-tab ${activeTab===tab?"active":""}`} onClick={()=>{setActiveTab(tab);setSelectedItem(null);setIsFormModalOpen(false);}}>{categoryLabel(tab)}</button>)}
      </div>

      <div className="enum-info">
        {activeTab==="FEED"?<><b>Feed inventory:</b> Existing feeding deductions remain unchanged. KG, LITRE and UNIT stock continue to use the current Feed workflow.</>:activeTab==="MEDICINE"?<><b>Medicine inventory:</b> Stock is deducted only when a linked task is marked Given. Expired stock and incompatible units are blocked.</>:<><b>Vaccine inventory:</b> Given tasks deduct actual stock. Vial stock uses the configured doses-per-vial conversion and is never treated as one vial per dose.</>}
      </div>

      {error ? (
        <div className="error-message">{error}</div>
      ) : (
        <div className="table-container">
          <table className="inventory-table">
            <thead>
              <tr>
                <th>Item Name</th>
                <th>Quantity</th>
                <th>Unit</th>
                {activeTab!=="FEED"&&<th>Expiry Date</th>}
                <th>Threshold</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={activeTab==="FEED"?6:7} style={{ textAlign: "center", padding: "3rem", color: "#64748B" }}>Loading...</td></tr>
              ) : visibleInventory.length === 0 ? (
                <tr><td colSpan={activeTab==="FEED"?6:7} style={{ textAlign: "center", padding: "3rem", color: "#64748B" }}>No {categoryLabel(activeTab).toLowerCase()} items yet.</td></tr>
              ) : (
                visibleInventory.map((it) => {
                  const isLow = it.lowStockAlert === true || (Number(it.quantity ?? 0) <= Number(it.minThreshold ?? -1));
                  const expired=isExpired(it);
                  return (
                    <tr key={it.id}>
                      <td style={{ fontWeight: 700 }}>{it.itemName}</td>
                      <td>{Number(it.quantity ?? 0).toLocaleString(undefined, { maximumFractionDigits: 3 })}</td>
                      <td><span className="chip">{it.unit}</span></td>
                      {activeTab!=="FEED"&&<td>{it.expiryDate?new Date(`${it.expiryDate}T00:00:00`).toLocaleDateString():"—"}</td>}
                      <td>{it.minThreshold ?? "-"}</td>
                      <td><span className={expired?"expired-stock":isLow ? "low-stock-alert" : "in-stock"}>{expired?"Expired":isLow ? "Low Stock" : "In Stock"}</span></td>
                      <td><div className="action-buttons">
                        <button className="action-btn restock" onClick={() => setRestockItem(it)}>Restock</button>
                        <button className="action-btn history" onClick={() => showHistory(it)}>History</button>
                        <button className="action-btn edit" title="Edit" onClick={() => { setSelectedItem(it); setIsFormModalOpen(true); }}><EditIcon /> Edit</button>
                        <button className="action-btn delete" title="Delete" onClick={() => deleteInventory(it.id)}><DeleteIcon /> Delete</button>
                      </div></td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      )}

      {restockItem&&<RestockModal item={restockItem} onClose={()=>setRestockItem(null)} onSave={restockInventory}/>} 
      {(historyLoading||history)&&<HistoryModal data={history} loading={historyLoading} onClose={()=>{setHistory(null);setHistoryLoading(false);}}/>}

      <InventoryFormModal
        isOpen={isFormModalOpen}
        onClose={() => setIsFormModalOpen(false)}
        onSave={saveInventory}
        initialData={selectedItem}
        category={activeTab}
      />

    </>
  );
}
